<template>
  <footer>
    <span>Made in Germany</span>
  </footer>
</template>
<script>
export default {
  name: 'Made'
}
</script>
<style lang="scss" scoped>
@import "../assets/css/variables.scss";
footer {
  width: 100%;
  background: #2b2b2b;
  text-align: center;
  padding: 20px 0;
  span {
    font-size: 14px;
    line-height: 1.2;
    margin: 0;
    font-family: $secondaryFont;
    color: $secondaryFontColor;
  }
}
</style>
